import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import profile_pic from "../assets/images/rafael-desenvolvimento-fullstack-frontend-backend-react-wordpress-php-html-css-devops-sql-mysql.png";

const skills = [
  {
    title: ".NET",
    items: [
      "Desenvolvimento e manutenção de aplicações em ASP.NET MVC com C#.",
      "Atuação em módulos críticos com certificado digital, Conta Gov.br e assinatura eletrônica.",
      "Implementação de regras de negócio em camadas de aplicação e serviços.",
    ],
  },
  {
    title: "Banco de Dados",
    items: [
      "Experiência com bancos de dados relacionais, especialmente SQL Server e MySQL.",
      "Criação de consultas, views, procedures e scripts para suporte às regras de negócio.",
      "Otimização de consultas e análise de desempenho.",
    ],
  },
  {
    title: "Frontend",
    items: [
      "Domínio de HTML5, JavaScript, CSS3, SASS e Styled Components.",
      "Experiência com React JS e conhecimento em Vue.js e Next.js.",
      "Experiência com Tailwind, Material UI, Bootstrap e desenvolvimento responsivo.",
      "Conhecimento em TypeScript, Git, Git Flow e Docker.",
    ],
  },
  {
    title: "WordPress / PHP",
    items: [
      "Desenvolvimento de sites institucionais, landing pages e projetos personalizados em WordPress.",
      "Criação e personalização de temas com Custom Post Types, Advanced Custom Fields e Elementor.",
      "Manutenção de sites WordPress, correção de bugs, ajustes em templates, melhorias visuais e suporte técnico.",
      "Desenvolvimento e customização de plugins para criação de funcionalidades específicas conforme a regra de negócio.",
      "Experiência com PHP, MySQL, HTML5, CSS3, SASS, JavaScript, responsividade e publicação em hospedagens.",
      "Otimização de layout, organização de estrutura, melhorias de performance e adequações para diferentes dispositivos.",
    ],
  },
  {
    title: "DevOps",
    items: [
      "Uso do Azure DevOps Boards para organizar tarefas, acompanhar progresso e colaborar com o time de desenvolvimento.",
      "Configuração de e-mail comercial usando domínio próprio e servidor de hospedagem.",
      "Criação e configuração de Droplets Linux.",
      "Linux: SSH, criação de usuários, permissões, grupos, Postfix e Dovecot.",
    ],
  },
];

export default class Home extends Component {
  render() {
    return (
      <main className="home-page">
        <section className="home-hero">
          <div
            className="picture"
            style={{ backgroundImage: `url(${profile_pic})` }}
          ></div>

          <div className="about-resume">
            <span className="home-hero-label">Desenvolvedor Full Stack</span>

            <h1>Rafael de Melo</h1>

            <p>
              Desenvolvedor com experiência em sistemas corporativos .NET,
              WordPress, PHP, frontend responsivo, autenticação segura e bancos
              de dados relacionais.
            </p>

            <div className="social">
              <a
                href="https://www.linkedin.com/in/raffademello/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>

              <a
                href="https://github.com/raffademello?tab=repositories"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FontAwesomeIcon icon={faGithub} size="2x" />
              </a>
            </div>

            <div className="home-hero-actions">
              <a href="/#/portfolio/net" className="btn-home-primary">
                Ver portfólio
              </a>

              <a href="/#/contato" className="btn-home-secondary">
                Entrar em contato
              </a>
            </div>
          </div>
        </section>

        <section className="home-section">
          <header className="portfolio-section-header">
            <span className="portfolio-section-label">Perfil profissional</span>

            <h2>Resumo profissional</h2>

            <p className="portfolio-section-description">
              Mais de 13 anos de experiência em desenvolvimento de software, com
              foco em sistemas corporativos, .NET, C#, SQL Server, autenticação
              segura, certificado digital e aplicações web.
            </p>
          </header>

          <div className="home-summary-card">
            <p>
              Sou formado em Sistemas de Informação pela Faculdade do Litoral
              Paulista (FALS) e atuo há mais de 13 anos com desenvolvimento de
              software.
            </p>

            <p>
              Nos últimos anos, atuei em aplicações corporativas em .NET,
              trabalhando com ASP.NET MVC, C# e bancos de dados relacionais.
              Também possuo experiência sólida no desenvolvimento de sites e
              soluções web com WordPress, Elementor, PHP, MySQL, HTML, CSS/SASS
              e JavaScript.
            </p>

            <p>
              Fui responsável pela manutenção e evolução do sistema ONR
              (Operador Nacional do Sistema de Registro Eletrônico de Imóveis),
              uma aplicação de grande porte. Durante o projeto, desenvolvi
              módulos de autenticação com certificado digital, Conta Gov.br e
              assinatura eletrônica de documentos.
            </p>
          </div>
        </section>

        <section className="home-section">
          <header className="portfolio-section-header">
            <span className="portfolio-section-label">
              Competências técnicas
            </span>

            <h2>Habilidades</h2>

            <p className="portfolio-section-description">
              Principais tecnologias e áreas de atuação em sistemas
              corporativos, frontend, WordPress, banco de dados e
              infraestrutura.
            </p>
          </header>

          <div className="skills-grid">
            {skills.map((skill) => (
              <article className="skill-card" key={skill.title}>
                <h3>{skill.title}</h3>

                <ul>
                  {skill.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>
      </main>
    );
  }
}
